import React from 'react';

import { CallNewPageContent } from './CallNewPageContent';

const CallNewPage = () => {
  return <CallNewPageContent />;
};

export default CallNewPage;
